export interface PaymentMethodFilterType {
  selectedPaymentMethods: server.dto.PaymentMethods[]
}

export const getSortedPaymentMethodLabels = (filter: PaymentMethodFilterType) => {
  return filter.selectedPaymentMethods.map(p => getLabel(p))
    .sort((a, b) => a.localeCompare(b));
};

export const getLabel = (paymetMethod: server.dto.PaymentMethods) => {
  return serverReference.paymentMethods.find((pm) => pm.value === paymetMethod)
    ?.text;
};

export const initialPaymentMethodFilter: PaymentMethodFilterType = {
  selectedPaymentMethods: []
};
